module.exports = __webpack_public_path__ + "static/media/BeetleBarber.06d6914c.jpg";